import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import { loadPermissions, hasPermission } from "API/UserAccess"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  moduleId,
  action,
  ...rest
}) => {
  const [permissionChecked, setPermissionChecked] = useState(false)
  const [hasAccess, setHasAccess] = useState(true)

  useEffect(() => {
    const checkPermission = async () => {
      if (!isAuthProtected || !moduleId) {
        console.log(`%c🔑 AUTH: Skip permission check (isAuth=${isAuthProtected}, moduleId=${moduleId})`, 'color: #6b7280')
        setHasAccess(true)
        setPermissionChecked(true)
        return
      }

      try {
        console.log(`%c🔑 AUTH: Checking permission for module=${moduleId} action=${action || 'view'}`, 'color: #8b5cf6')
        await loadPermissions()
        const allowed = hasPermission(moduleId, action || "view")
        console.log(`%c🔑 AUTH: Permission result: ${allowed ? '✅ ALLOWED' : '🚫 DENIED'} for module=${moduleId}`, allowed ? 'color: #22c55e' : 'color: #ef4444')
        setHasAccess(allowed)
      } catch (error) {
        console.warn("🔑 AUTH: Permission check error, allowing access:", error)
        // On error, allow access to prevent lockout
        setHasAccess(true)
      }
      setPermissionChecked(true)
    }

    checkPermission()
  }, [moduleId, action, isAuthProtected])

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !localStorage.getItem("authUser")) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        // Wait for permission check to complete
        if (isAuthProtected && moduleId && !permissionChecked) {
          console.log(`%c⏳ AUTH: Showing loading screen for module=${moduleId}`, 'color: #f59e0b')
          return (
            <Layout>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
                <p>Loading...</p>
              </div>
            </Layout>
          )
        }

        // If no access, redirect to dashboard
        if (!hasAccess) {
          return (
            <Redirect to={{ pathname: "/dashboard" }} />
          )
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }}
    />
  )
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  moduleId: PropTypes.number,
  action: PropTypes.string,
}

export default Authmiddleware
